export const WidgetUnknown = () => (<div>Unknown widget type</div>);
export default WidgetUnknown;
